import HeroSection from "./components/HeroSection";
import HotArticles from "./components/HotArticles";
import CategoryNav from "./components/CategoryNav";
import LatestArticles from "./components/LatestArticles";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

export default function Home() {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "51cg黑料揭秘",
    url: "https://51cgheibao.com",
    description: "51cg黑料深度揭秘与真相解析，汇聚最新爆料、用户反馈与深度分析",
    inLanguage: "zh-CN",
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "51cg黑料揭秘",
    url: "https://51cgheibao.com",
    description: "致力于为用户提供51cg平台最真实、最全面、最及时的爆料信息与深度分析",
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      { "@type": "Question", name: "51cg平台是正规平台吗？", acceptedAnswer: { "@type": "Answer", text: "根据目前的调查信息，51cg平台的运营主体信息不透明，存在多层股权嵌套。多个监管部门已对其展开调查。建议用户在充分了解风险之前，谨慎对待该平台。" } },
      { "@type": "Question", name: "51cg平台上的收益是真的吗？", acceptedAnswer: { "@type": "Answer", text: "据前员工爆料和用户反馈，51cg平台存在数据造假的情况。部分用户展示的高收益截图真实性存疑。平台承诺的高额收益缺乏实体经济支撑，存在庞氏骗局特征。" } },
      { "@type": "Question", name: "在51cg平台投资安全吗？", acceptedAnswer: { "@type": "Answer", text: "从目前掌握的信息来看，51cg平台存在多项安全隐患，包括数据安全漏洞、资金管理不规范、客服体系不健全等。多个安全研究机构和法律专家均对其风险水平提出了警告。" } },
      { "@type": "Question", name: "如何辨别类似51cg的风险平台？", acceptedAnswer: { "@type": "Answer", text: "可以通过以下几个维度来判断：运营主体是否透明可查、收益来源是否清晰合理、是否采用第三方资金托管、用户口碑是否真实多元、是否有合法的经营资质。" } },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <main>
        <HeroSection />
        <HotArticles />
        <CategoryNav />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
}